/** External links surfaced across the portal. */

/**
 * The Melio API Beta Program "book a call" calendar. Shown on the onboarding done step and on the
 * dashboard's production-access-pending panel so a partner awaiting production approval can schedule a call.
 */
export const SCHEDULE_URL = 'https://calendar.app.google/ZNcgNAh97AVU4dx47';
